import * as actionTypes from "../constants/actionTypes";
import * as actions from "../actions";
import { Observable } from "rxjs";

// Observable.ajax({
//   crossDomain: true,
//   method: "POST",
//   headers: { "Content-Type": "application/x-www-form-urlencoded" },
//   url: `http://case.dev.interconnessioni.it/api/item/types`,
//   body: {
//     userName: values.userName,
//     password: values.password
//   }
// });

// Observable.ajax({
//   crossDomain: true,
//   method: "POST",
//   headers: { "Content-Type": "application/x-www-form-urlencoded" },
//   url: `http://case.dev.interconnessioni.it/api/item/types`,
//   body: {
//     token: token
//   }
// });

export const loginEpic = action$ =>
  action$.ofType(actionTypes.LOGIN).mergeMap(action => {
    // const { values } = action.payload;
    // console.log("payload ", action.payload);
    return Observable.ajax({
      crossDomain: true,
      url: `https://swapi.co/api/people/1`
    })
      .map(({ response }) => {
        const user = {
          firstName: "FirstName",
          lastName: "LastName",
          role: "admin",
          token: "token"
        };
        return actions.loginSuccess(user);
      })
      .catch(error => Observable.of(actions.loginError(error.message)))
      .concat(Observable.of(actions.getMainFilters()));
  });

export const loginWithTokenEpic = action$ =>
  action$.ofType(actionTypes.LOGIN_WITH_TOKEN).mergeMap(action => {
    // const { token } = action.payload;
    // console.log("payload ", action.payload);
    return Observable.ajax({
      crossDomain: true,
      url: `https://swapi.co/api/people/1`
    })
      .map(({ response }) => {
        const user = {
          firstName: "FirstName",
          lastName: "LastName",
          role: "admin",
          token: "token"
        };
        return actions.loginSuccess(user);
      })
      .catch(error => Observable.of(actions.loginError(error.message)))
      .concat(Observable.of(actions.getMainFilters()));
  });

export const redirectAfterLoginEpic = (action$, store) =>
  action$.ofType(actionTypes.LOGIN_SUCCESS).mergeMap(action => {
    const state = store.getState().auth;
    const redirectToReferrer = state.from !== null;
    const from = redirectToReferrer ? state.from : "/home";
    return Observable.of(actions.redirectToPage(from));
  });

export const logoutEpic = action$ =>
  action$.ofType(actionTypes.LOGOUT).mergeMap(action =>
    Observable.ajax({
      crossDomain: true,
      url: `https://swapi.co/api/people/1`
    })
      .map(({ response }) => actions.logoutSuccess(response))
      .catch(error => Observable.of(actions.logoutError(error.message)))
  );

export const recoverPasswordEpic = action$ =>
  action$.ofType(actionTypes.RECOVER_PASSWORD).mergeMap(action => {
    const { email } = action.payload;
    console.log("email ", email);
    return Observable.ajax({
      crossDomain: true,
      url: `https://swapi.co/api/people/1`
    })
      .map(({ response }) => actions.recoverPasswordSuccess())
      .catch(error =>
        Observable.of(actions.recoverPasswordError(error.message))
      );
  });

export const redirectAfterLogoutEpic = action$ =>
  action$
    .ofType(actionTypes.LOGOUT_SUCCESS)
    .mergeMap(action => Observable.of(actions.redirectToPage("/")));



// WEBPACK FOOTER //
// ./src/epics/auth.js